import { render, staticRenderFns } from "./AnalyticsDelivery.vue?vue&type=template&id=1b4e67b8&scoped=true&"
import script from "./AnalyticsDelivery.vue?vue&type=script&lang=js&"
export * from "./AnalyticsDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4e67b8",
  null
  
)

export default component.exports